import { format } from 'date-fns';
import { isPresent } from 'Shared/utils';

export const sanitizeString = (value: string, isEditable: boolean = true) =>
  isEditable ? (value !== '' ? value : null) : undefined;
/* we store boolean values as strings on the form so hence the transform */
export const sanitizeBoolString = (
  value: string,
  isEditable: boolean = true
) => (isEditable ? (value !== '' ? value === 'true' : null) : undefined);
export const sanitizeNumString = (value: string, isEditable: boolean = true) =>
  isEditable ? value.replace(/\D/g, '') || null : undefined;
export const sanitizeNum = (value: string, isEditable: boolean = true) => {
  const numberString = sanitizeNumString(value);
  return isEditable
    ? numberString
      ? parseInt(numberString)
      : null
    : undefined;
};
/* if there's no values set for any keys in object, set object to undefined */
export const sanitizeObj = (
  obj: Record<string, string | boolean | number | undefined>
) =>
  Object.keys(obj).some((k) => isPresent(obj[k]) && k !== '') ? obj : undefined;
export const sanitizeDate = (value: string, isEditable: boolean = true) => {
  try {
    return isEditable
      ? value !== ''
        ? format(Date.parse(value), 'yyyy-MM-dd')
        : null
      : undefined;
  } catch {
    return null;
  }
};
/*
  Sanitize the string if not masked or a masked status value has been updated
*/
export const sanitizeMaskedString = (
  value: string,
  initialValue: string,
  isEditable: boolean,
  isMasked: boolean
) =>
  !isMasked || (isMasked && value !== initialValue)
    ? sanitizeString(value, isEditable)
    : undefined;
export const sanitizeMaskedDate = (
  value: string,
  isEditable: boolean = true
) => (value.includes('*') ? undefined : sanitizeDate(value, isEditable));
export const sanitizeMaskedNumString = (
  value: string,
  isEditable: boolean = true
) => (value.includes('*') ? undefined : sanitizeNumString(value, isEditable));
